import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Typography, Grid, Link, Divider, Stack } from '@mui/material';
import { Telegram, Security, WarningAmber, Shield } from '@mui/icons-material';

export default function PublicFooter() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#070f1a',
        color: '#94a3b8',
        pt: 8,
        pb: 6,
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
      }}
    >
      <Container maxWidth="lg">
        {/* Risk Disclaimer Box */}
        <Box
          sx={{
            p: 3,
            mb: 6,
            borderRadius: 3,
            bgcolor: 'rgba(239, 68, 68, 0.06)',
            border: '1px solid rgba(239, 68, 68, 0.2)',
          }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1.5 }}>
            <WarningAmber sx={{ color: '#f87171', fontSize: 24 }} />
            <Typography variant="subtitle1" sx={{ color: '#f87171', fontWeight: 700 }}>
              Mandatory Regulatory & Stock Market Risk Disclaimer
            </Typography>
          </Stack>
          <Typography variant="body2" sx={{ color: '#cbd5e1', lineHeight: 1.7, fontSize: '0.82rem' }}>
            <strong>1. Not SEBI Registered:</strong> We are NOT registered with the Securities and Exchange Board of India (SEBI) as Investment Advisers, Research Analysts, or Portfolio Managers. All content, signals, indicators, algorithm outputs, and notifications shared via our Telegram bot and web platform are intended strictly for educational, research, and informational purposes only.
          </Typography>
          <Typography variant="body2" sx={{ color: '#cbd5e1', lineHeight: 1.7, mt: 1, fontSize: '0.82rem' }}>
            <strong>2. High Risk Warning:</strong> Stock, equity derivatives, options, and futures trading involve substantial risk of financial loss and are not suitable for all investors. You can lose some or all of your invested capital. Leveraged derivative positions may lead to losses exceeding your initial deposit.
          </Typography>
          <Typography variant="body2" sx={{ color: '#cbd5e1', lineHeight: 1.7, mt: 1, fontSize: '0.82rem' }}>
            <strong>3. No Guarantee of Profit:</strong> Past performance, backtest metrics, simulation runs, or previous notifications are no guarantee or indicator of future returns. We make no representations or warranties regarding profits or trading outcomes. You assume total responsibility and risk for your trades. Always consult an authorized financial advisor before executing trades.
          </Typography>
        </Box>

        {/* Footer Links & Info */}
        <Grid container spacing={4} sx={{ mb: 4 }}>
          <Grid item xs={12} md={5}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: '10px',
                  background: 'linear-gradient(135deg, #2563eb 0%, #0088cc 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Telegram sx={{ color: '#fff', fontSize: 22 }} />
              </Box>
              <Typography variant="h6" sx={{ color: '#ffffff', fontWeight: 700 }}>
                AlphaTrading Alerts
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#94a3b8', lineHeight: 1.6, maxWidth: 380 }}>
              Automated high-precision algorithmic trading alerts delivered straight to your Telegram messenger in real time.
            </Typography>
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#64748b', fontSize: '0.75rem' }}>
                <Security sx={{ fontSize: 16, color: '#10b981' }} /> 256-Bit SSL Encrypted
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#64748b', fontSize: '0.75rem' }}>
                <Shield sx={{ fontSize: 16, color: '#38bdf8' }} /> Verified Telegram Bot
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={6} md={3}>
            <Typography variant="subtitle2" sx={{ color: '#ffffff', fontWeight: 700, mb: 2 }}>
              Legal & Compliance
            </Typography>
            <Stack spacing={1.2}>
              <Link component={RouterLink} to="/terms" sx={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.85rem', '&:hover': { color: '#ffffff' } }}>
                Terms & Conditions
              </Link>
              <Link component={RouterLink} to="/privacy" sx={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.85rem', '&:hover': { color: '#ffffff' } }}>
                Privacy Policy
              </Link>
              <Link component={RouterLink} to="/refund-policy" sx={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.85rem', '&:hover': { color: '#ffffff' } }}>
                Refund & Cancellation Policy
              </Link>
            </Stack>
          </Grid>

          <Grid item xs={6} md={4}>
            <Typography variant="subtitle2" sx={{ color: '#ffffff', fontWeight: 700, mb: 2 }}>
              Support & Inquiries
            </Typography>
            <Typography variant="body2" sx={{ color: '#94a3b8', mb: 1 }}>
              Official Telegram Bot: <strong>@JigendraTradingAlerts_bot</strong>
            </Typography>
            <Typography variant="body2" sx={{ color: '#94a3b8', mb: 1 }}>
              Service: Algorithmic Market Notifications & Signal Feed
            </Typography>
            <Typography variant="body2" sx={{ color: '#94a3b8' }}>
              Subscription: ₹1,000 / month (30 Days Active Access)
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.08)', my: 3 }} />

        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
          <Typography variant="caption" sx={{ color: '#64748b' }}>
            © {new Date().getFullYear()} Jigendra Trading Alerts. All rights reserved.
          </Typography>
          <Typography variant="caption" sx={{ color: '#64748b' }}>
            Built for serious traders seeking algorithmic execution intelligence.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
